import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetSolicitudPagoDirectoByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetSolicitudPagoDirectoByUser = () => {
  const [loadingGetSolicitudPagoDirectoByUser, setLoadingGetSolicitudPagoDirectoByUser] = useState(false);
  const [successGetSolicitudPagoDirectoByUser, setSuccessGetSolicitudPagoDirectoByUser] = useState(false);
  const [errorGetSolicitudPagoDirectoByUser, setErrorGetSolicitudPagoDirectoByUser] = useState<any>(null);
  const [dataGetSolicitudPagoDirectoByUser, setDataSolicitudPagoDirectoByUser] = useState<any>(null);

  const [statusGetSolicitudPagoDirectoByUser, setStatusGetSolicitudPagoDirectoByUser] =
    useState<StatusGetSolicitudPagoDirectoByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apirecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getSolicitudPagoDirectoByUser = async (
    userId: string,
    expedienteId: string = null,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudPagoDirectoByUser(true);
    setSuccessGetSolicitudPagoDirectoByUser(false);
    setErrorGetSolicitudPagoDirectoByUser(null);

    try {
      const res = await apirecord.getSolicitudPagoDirectoIncapacidadTemporalByUser(userId, expedienteId);

      setStatusGetSolicitudPagoDirectoByUser({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetSolicitudPagoDirectoByUser(true);
      setDataSolicitudPagoDirectoByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetSolicitudPagoDirectoByUser({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetSolicitudPagoDirectoByUser(err);
      console.error("Error en getSolicitudPagoDirectoByUser:", err);

      throw err;

    } finally {
      setLoadingGetSolicitudPagoDirectoByUser(false);
    }
  };

  return {
    getSolicitudPagoDirectoByUser,
    loadingGetSolicitudPagoDirectoByUser,
    successGetSolicitudPagoDirectoByUser,
    errorGetSolicitudPagoDirectoByUser,
    dataGetSolicitudPagoDirectoByUser,
    statusGetSolicitudPagoDirectoByUser
  };
};

export default useGetSolicitudPagoDirectoByUser;
